import { __decorate, __metadata } from "tslib";
import { AppRequest } from '@core/shared/app-request';
import { IsString, Model, ModelId } from '@core/shared/model';
import { AppRequestMethod } from '@core/shared/request';
import { Expose } from 'class-transformer-global-storage';
let DocumentationGetDocResponse = /*#__PURE__*/(() => {
  let DocumentationGetDocResponse = class DocumentationGetDocResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", String)], DocumentationGetDocResponse.prototype, "content", void 0);
  DocumentationGetDocResponse = __decorate([ModelId("DocumentationGetDocResponse") // auto-generated by generate-model-ids
  ], DocumentationGetDocResponse);
  return DocumentationGetDocResponse;
})();
export { DocumentationGetDocResponse };
;
let DocumentationGetDocRequest = /*#__PURE__*/(() => {
  let DocumentationGetDocRequest = class DocumentationGetDocRequest extends Model {
    static {
      this.Response = DocumentationGetDocResponse;
    }
  };
  __decorate([Expose(), IsString(), __metadata("design:type", String)], DocumentationGetDocRequest.prototype, "docPath", void 0);
  DocumentationGetDocRequest = __decorate([AppRequest('admin/documentation', 'docs', {
    httpMethod: AppRequestMethod.POST
  }), ModelId("DocumentationGetDocRequest") // auto-generated by generate-model-ids
  ], DocumentationGetDocRequest);
  return DocumentationGetDocRequest;
})();
export { DocumentationGetDocRequest };